import React from 'react';
import { useDemo } from '../context/DemoContext';
import UnifiedChatView from './UnifiedChatView';

const MainTabbedView: React.FC = () => {
  const { state, startDemo, pauseDemo, resetDemo } = useDemo();

  return (
    <div className="fullscreen-demo">
      {/* Single Header with All Info */}
      <div className="demo-header">
        <div className="header-left">
          <div className="header-title">
            <img src="/Aisberg-Symbol-Square-Small.png" alt="Aisberg" className="header-logo" />
            <h2 className="text-lg">Aisberg Artificial Mind Demo</h2>
          </div>
        </div>
        
        {/* Demo Controls in Header */}
        <div className="demo-controls">
          <button
            onClick={state.isComplete ? resetDemo : (state.isAutoPlaying ? pauseDemo : startDemo)}
            className={`btn ${
              state.isComplete ? 'btn-secondary' : (state.isAutoPlaying ? 'btn-warning' : 'btn-primary')
            }`}
          >
            {state.isComplete ? '🔄 Restart' : (state.isAutoPlaying ? '⏸️ Pause' : (state.currentStep === 0 ? '▶️ Start Demo' : '▶️ Resume'))}
          </button>
          {!state.isComplete && (
            <button
              onClick={resetDemo}
              className="btn"
            >
              🔄 Reset
            </button>
          )}
        </div>
      </div>

      {/* Chat Interface directly in grid */}
      <UnifiedChatView />
    </div>
  );
};

export default MainTabbedView;